/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMagnetFilled = createReactComponent("filled", "magnet-filled", "IconMagnetFilled", [["path", { "d": "M21 9v4a9 9 0 0 1 -18 0v-4h7v4a2 2 0 1 0 4 0v-4zm-3 -7a3 3 0 0 1 3 3v2h-7v-2a3 3 0 0 1 3 -3zm-11 0a3 3 0 0 1 3 3v2h-7v-2a3 3 0 0 1 3 -3z", "key": "svg-0" }]]);

export { IconMagnetFilled as default };
//# sourceMappingURL=IconMagnetFilled.mjs.map
